import type { ComponentProps } from 'react';

import { Text } from '~components/Typography';
import { routes } from '~constants/routes';
import { Link } from '~shared/ui/atoms/Link';
import {
	nickStyle,
	StyledCreatorLink,
} from '~shared/ui/molecules/CreatorLink/styles';

export interface CreatorLinkProps extends ComponentProps<typeof Text> {
	by: string;
	nick: string | null | undefined;
	fallback: string;
}

export const CreatorLink = ({
	by = 'by ',
	nick,
	fallback = 'Community',
	...props
}: CreatorLinkProps) => {
	return (
		<StyledCreatorLink {...props}>
			<Text color="grey-52-solid" size="S">
				{by}{' '}
			</Text>
			<Text color="grey-68-solid" size="S">
				{nick ? (
					<Link className={nickStyle} href={routes.creator.slug(nick)}>
						{nick}
					</Link>
				) : (
					fallback
				)}
			</Text>
		</StyledCreatorLink>
	);
};
